import { render, staticRenderFns } from "./PurpleCard.vue?vue&type=template&id=7e90a279&scoped=true"
import script from "./PurpleCard.vue?vue&type=script&lang=js"
export * from "./PurpleCard.vue?vue&type=script&lang=js"
import style0 from "./PurpleCard.vue?vue&type=style&index=0&id=7e90a279&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e90a279",
  null
  
)

export default component.exports